import React from 'react';
import ProjectScope from './../projectScope/projectScope';
import QuantityTextField from "./../quantityTextField";
import Analytics from './../../analytics';

export default class QuoteSummaryDetailFeatureItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: props.quantity
    };
    this.timeout = null;
  }

  componentWillReceiveProps(nextProps, oldProps) {
    if (nextProps.quantity !== oldProps.quantity) {
      this.setState({quantity: nextProps.quantity});
    }
  }

  handleQuantityChange = (quantity) => {
    this.setState({quantity: quantity});
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      ProjectScope.updateFeatureQuantity(this.props.featureID, quantity);
    }, 300);
  };

  handleQuantityBlur = () => {
    Analytics.sendClickEvent('summary-quantity-change: ' + this.props.name);
  };

  render() {
    let cost = +this.props.featureCost;
    if (cost === 0) {
      cost = "Included";
    } else {
      cost = "$" + cost.toFixed(2);
    }

    const lineItemClasses = "review-submit-list-total review-submit-list-controller" + (this.props.hidePrice ? " hide" : "");

    return (
      <div className="review-submit-qd-listitemrenderer">
        <div className="review-submit-list-title review-submit-list-controller">{this.props.name}</div>
        <QuantityTextField value={this.state.quantity} onBlur={this.handleQuantityBlur}
                           className="review-submit-list-quantity review-submit-list-controller"
                           onChange={this.handleQuantityChange} title="Feature quantity"/>
        <div className={lineItemClasses}>{cost}</div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/projectSummary/quoteSummaryDetailFeatureItem.js